import AbstractApiModel from '@/models/abstracts/AbstractApiModel';
import doc from '@model-core/decorators/doc';

/** Signataire d'une feuille d'heures (enum App\Entity\TimeSheetSignatureType de l'API, GET /time_sheet_signature_types) : Employé, Manager, Dirigeant */
export default class TimeSheetSignatureTypeModel extends AbstractApiModel {
  protected _path = '/time_sheet_signature_types/{?id}';

  @doc.string declare reference: string;
  @doc.string declare label: string;

  /** URN à envoyer à l'API pour écrire la relation (corps d'un POST / PATCH) ; un filtre prend l'id */
  get urn(): string {
    return this.get<string, string>('@urn', `$:teiji:time_sheet_signature_type:${this.id}`);
  }
}
